import { useSelector } from 'react-redux';
import { Button, Typography, Modal } from '@safedns/skydns-ui-react-lib';

import Notification from '../UI/notification/Notification';

import { getWordEnding } from '../../utils/getWordEnding';
import './Collections.scss';

const SubmitBar = ({
  isFormValid,
  buttonText,
  onSubmit,
  dialogState,
  dialogAction,
}) => {
  const arrayOfSelectedItems = useSelector(
    (state) => state.tree.selectedUsersIdsForBackend
  );

  return (
    <>
      <div className="submit-bar">
        Выбрано: {getWordEnding(arrayOfSelectedItems.length)}
        {isFormValid ? (
          <Button variant="secondary" onClick={() => dialogAction(true)}>
            Отмена
          </Button>
        ) : (
          <Button variant="secondary" href="/collections">
            Отмена
          </Button>
        )}
        <Button variant="primary" isDisabled={!isFormValid} onClick={onSubmit}>
          {buttonText}
        </Button>
      </div>

      <Notification />

      <Modal
        isOpen={dialogState}
        title="Отменить создание коллекции?"
        sx={{ maxWidth: 460 }}
        onClose={() => dialogAction(false)}
      >
        <div className="submit-bar-modal-content">
          <Typography variant="body1" sx={{ paddingBottom: 24 }}>
            Все изменения не будут сохранены
          </Typography>

          <div className="submit-bar-modal-buttons">
            <Button variant="secondary" onClick={() => dialogAction(false)}>
              Отменить
            </Button>
            <Button href="/collections" variant="primary">
              Продолжить
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default SubmitBar;
